export default __webpack_public_path__ + "static/media/pimgs.d6a93754.png";